import {axiosInstance, BASE_URLS} from "@/src/shared/api";
import {ProcessInstanceType} from "@/src/shared/schemas";

export const runAction = async ({
    actionName,
    body,
 }:{
    actionName: string;
    body: Pick<ProcessInstanceType, 'id' | 'processId' | 'contextInstance' | 'activeStepId'>;
}) => {
    const response = await axiosInstance.post(`${BASE_URLS.ACTION_API_CALL}/${actionName}`, body);
    return response.data;
}

export const runApiCall = async ({
     actionName,
     body,
 }:{
    actionName: string;
    body: Pick<ProcessInstanceType, 'id' | 'processId' | 'contextInstance' | 'activeStepId'>;
}) => {
    const response = await axiosInstance.post(`${BASE_URLS.API_CALL}/${actionName}`, body);
    return response.data;
}
